import { render, staticRenderFns } from "./SystemColors.vue?vue&type=template&id=423f9fbc&"
import script from "./SystemColors.vue?vue&type=script&lang=js&"
export * from "./SystemColors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports